// extracted by mini-css-extract-plugin
export default {"saved-address-items":"SavedAddressItems_saved-address-items__hfCxd"};